import axios from 'axios'
const url = process.env.VUE_APP_BACKEND_URL
export default {
    getUsers() {
        return axios.get(url + 'get-users/').then(response => response.data)
    },
    getPlanUsers(filterUsersHavingUidRelation = false) {
        const urlParams = filterUsersHavingUidRelation ? 'get-plan-users/true' : 'get-plan-users'
        return axios.get(url + urlParams).then(response => response.data)
    },
    changeOrderId(users) {
        return axios
            .post(url + 'users/change-oids/', users)
            .then(response => response.data)
    },
    addPlanUser(name) {
        return axios.post(url + 'plan-users/add/', {name}).then(response => response.data)
    },
    editPlanUser(oldName, newName) {
        return axios.post(url + 'plan-users/edit/', {oldName, newName}).then(response => response.data)
    },
    deletePlanUser(id) {
        return axios.post(url + 'plan-users/delete/', {id}).then(response => response.data)
    },
    linkPlanUser(uid, id) {
        return axios.post(url + 'plan-users/link/', {uid, id}).then(response => response.data)
    },
};
